var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 27,
    viewBox: "0 0 43 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25774_184136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9534 2.90405H15.479V23.5448H26.9534V2.90405Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2081 13.2247C16.2081 9.03876 18.1675 5.30667 21.2176 2.90429C18.9855 1.14615 16.1732 0.098877 13.1136 0.098877C5.87195 0.098877 0 5.97629 0 13.2247C0 20.4731 5.87195 26.3505 13.1136 26.3505C16.1732 26.3505 18.9887 25.3032 21.2176 23.5451C18.1675 21.1427 16.2081 17.4138 16.2081 13.2247Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4354 13.2247C42.4354 20.4731 36.5635 26.3505 29.3218 26.3505C26.2622 26.3505 23.4467 25.3032 21.2178 23.5451C24.2679 21.1427 26.2273 17.4138 26.2273 13.2247C26.2273 9.03559 24.2679 5.30667 21.2178 2.90429C23.4499 1.14615 26.2622 0.098877 29.3218 0.098877C36.5635 0.098877 42.4354 5.97629 42.4354 13.2247ZM41.183 21.3585V20.9364H41.3542V20.8507H40.9199V20.9364H41.0911V21.3585H41.183ZM42.0232 21.3585V20.8475H41.8901L41.7379 21.1966L41.5857 20.8475H41.4525V21.3585H41.5476V20.9745L41.6903 21.3045H41.7886L41.9313 20.9713V21.3553H42.0264L42.0232 21.3585Z",
    fill: "#F37439"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25774_184136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard-logo.da773d851192077a95309c98dc9e09b7.svg";
export { ForwardRef as ReactComponent };